const billingInfoResources = {
    title: 'Details',
    updateButtonText: 'Update',
    withdrawalFormName: 'withdrawalBankAccountForm',
    depositFormName: 'depositBankAccountForm',
    bankAccountModelName: 'bankAccount',
    bankAccountCheckboxLabel: 'Use the same bank account as submitted for withdrawals.',
    billingInfoRequiredText: 'Billing Info is required.'
};
export default billingInfoResources;